import { render, staticRenderFns } from "./index.vue?vue&type=template&id=296d7a2e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=296d7a2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296d7a2e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProjectForm: require('/builds/knockmedia/knock-vi-web/src/components/ProjectForm.vue').default})
